import React, { Component } from "react";
import { connect } from "react-redux";
import ReactPaginate from "react-paginate";
import { withRouter } from "react-router-dom";

import ReactTooltip from "react-tooltip";
import walletIconn from "../../../assets/img/dashboard/Group 954.svg";
import Table from "../../common/components/Table";
import recommendationsActions from "../actions";
import projectActions from "../../project/actions";
import TableTopIcons from "../../common/components/TableTopIcons";
import chartIcon from "../../../assets/img/dashboard/dsh-chart.svg";
import { Dropdown } from "react-bootstrap";
import { checkPermission } from "../../../config/utils";
import { permissions as permissionConfig } from "../../../config/permissions";

import ReactSelect from "react-select";
import RecommendationPreview from "./RecommendationPreview";
import { BulkQaQc } from "./BulkQaQc";
import BulkQaStatusUpdate from "./BulkQaStatusUpdate";
import { MoreFilters } from "./MoreFilters";
import { getCapitalRequestLabel } from "../../../utils/capitalRequestLabel";

class RecommendationsMain extends Component {
    state = {
        isCheckedWord: true,
        isCheckedPdf: true,
        show: false,
        showMoreFilter: false,
        isSimpleNarrativeTextWord: true,
        isSimpleNarrativeTextPdf: true,
        selectedImage: null
    };

    toolbarRef = React.createRef();
    selectionBarRef = React.createRef();
    filterPanelRef = React.createRef();

    componentDidMount = () => {
        this.setState({
            showMoreFilter: this.isMoreFiltered()
        });
        if (typeof ResizeObserver !== "undefined") {
            this.headerResizeObserver = new ResizeObserver(this.adjustTableHeightToAvoidWindowScroll);
            [this.toolbarRef, this.selectionBarRef, this.filterPanelRef].forEach(ref => {
                if (ref.current) this.headerResizeObserver.observe(ref.current);
            });
        }
        window.addEventListener("resize", this.adjustTableHeightToAvoidWindowScroll);
    };
    componentDidUpdate(prevProps, prevState) {
        if (this.props?.isSmartChartView && !this.props?.hasSurveyAssign) {
            const { tableParams } = this.props;
            const newShowMoreFilter = tableParams.image_or_not ? true : false;

            if (prevState.showMoreFilter !== newShowMoreFilter) {
                this.setState({
                    showMoreFilter: newShowMoreFilter
                });
            }
        }
    }

    componentWillUnmount() {
        if (this.headerResizeObserver) {
            this.headerResizeObserver.disconnect();
        }
        window.removeEventListener("resize", this.adjustTableHeightToAvoidWindowScroll);
    }

    adjustTableHeightToAvoidWindowScroll = () => {
        const tableNode = this.props.tableRef?.current;
        if (!tableNode) return;

        tableNode.style.removeProperty("max-height");
        tableNode.style.removeProperty("min-height");

        const overflow = Math.round(document.documentElement.scrollHeight - document.documentElement.clientHeight);

        if (overflow > 5) {
            const computed = window.getComputedStyle(tableNode);
            const naturalMax = parseFloat(computed.maxHeight);
            const naturalMin = parseFloat(computed.minHeight);
            const reduceBy = overflow + 5;
            if (!Number.isNaN(naturalMax)) {
                tableNode.style.setProperty("max-height", `${Math.max(naturalMax - reduceBy, 100)}px`, "important");
            }
            if (!Number.isNaN(naturalMin)) {
                tableNode.style.setProperty("min-height", `${Math.max(naturalMin - reduceBy, 100)}px`, "important");
            }
        }
    };

    assignContent = async () => {
        await this.props.assignProjectModal();
    };
    toggleChangeWord = async (e, check) => {
        if (check === "isCheckedWord") {
            await this.setState({
                isCheckedWord: !e.target.checked
            });
        } else {
            await this.setState({
                isCheckedWord: true
            });
        }
    };

    toggleChangePdf = async (e, check) => {
        if (check === "isCheckedPdf") {
            await this.setState({
                isCheckedPdf: !e.target.checked
            });
        } else {
            await this.setState({
                isCheckedPdf: true
            });
        }
    };

    clearExport = () => {
        this.setState({
            isCheckedPdf: true,
            isCheckedWord: true,
            isSimpleNarrativeTextWord: true,
            isSimpleNarrativeTextPdf: true
        });
    };
    toggleMoreFilter = async data => {
        this.setState({ showMoreFilter: !this.state.showMoreFilter });
    };

    isMoreFiltered = () => {
        const { tableParams = {}, isSmartChartView = false } = this.props;
        if (
            tableParams.image_or_not ||
            ((tableParams.recommendation_assigned_true ||
                tableParams?.surveyor ||
                tableParams?.requestor ||
                tableParams?.infrastructure_request ||
                tableParams?.water ||
                tableParams?.energy ||
                tableParams?.fmp ||
                tableParams?.facility_master_plan ||
                tableParams?.recommendation_type ||
                tableParams?.budget_priority ||
                tableParams?.qa_qc_status ||
                tableParams?.opinions_cost_vs_project_total ||
                tableParams?.caption_missing ||
                tableParams?.caption_missing === false ||
                tableParams?.review_status) &&
                !isSmartChartView)
        ) {
            return true;
        }
        return false;
    };

    render() {
        const {
            showWildCardFilter,
            paginationParams,
            currentViewAllUsers,
            showViewModal,
            tableData,
            handleGlobalSearch,
            toggleWildCardFilter,
            updateCurrentViewAllUsers,
            handleDeleteRecommendations,
            showEditPage,
            handlePerPageChange,
            handlePageClick,
            showAddForm,
            match: {
                params: { section }
            },
            showInfoPage,
            updateSelectedRow,
            selectedRowId,
            globalSearchKey,
            updateWildCardFilter,
            wildCardFilter,
            handleHideColumn,
            getListForCommonFilterRecommendation,
            updateCommonFilter,
            commonFilter,
            resetAllFilters,
            updateTableSortFilters,
            updateLastSortFilter,
            resetSort,
            tableParams,
            isBuildingLocked,
            summaryRowData,
            showRestoreModal,
            selectFilterHandler,
            permissions,
            selectFilterHandlerInitiative,
            showAddButton,
            hasExport,
            hasNewlyCreated,
            hasNewlyEdited,
            hasEdit,
            hasDelete,
            hasInfoPage,
            entity,
            exportExcelAllTrades = null,
            exportAllTradesLoading = false,
            exportWordLoading = false,
            selectedRecomIds,
            handleSelectRecom,
            handleSelectAllRecom,
            isBudgetPriority,
            isFullscreen,
            tableRef,
            hasViewMyRecommendation,
            hasFilterByImages,
            hasFilterByMyQa,
            hasFilterByQaStatus,
            filterBySurveyor,
            filterByImages,
            filterByReviews,
            filterByQaStatus,
            filterByIR,
            resetAll,
            isColunmVisibleChanged,
            hasMultiAction,
            handleEditMultiSelectedData,
            showSelectedRecom,
            clearSelection,
            everyItemCheckedPerPage,
            selectWholeRecommendation,
            hasIrRecommendation,
            priorityElementsData = [],
            exportSelectedRecom,
            multiExportPdfLoader,
            multiExportWordLoader,
            exportToWordFile,
            showViewModalExport,
            showViewImport,
            exportToExcelFiles,
            tableDataExportFilters,
            isInputMode,
            handleCellFocus,
            handleCellValueChange,
            lineEditingEnabled,
            toggleLineEditing,
            handleColumnPin,
            updateColumnWidthInConfig,
            pinnedColumnsRef,
            isSmartChartView = false,
            createAssetRecommendation,
            openFiltersPopup,
            filteredCount,
            toggleShiftCspModal,
            dashboardFilterParams,
            myFilters,
            toggleAppliedFiltersPopup,
            isCapitalRequest,
            isCrLinkedRecommendations,
            createRecommendationFromCr,
            toggleLinkRecommendationModal,
            isCrLinkPicker = false,
            unlinkSelectedRecommendations,
            isTableResetting = false,
            isNormalRecomGroupingLoading,
            resetAllTableConfig,
            openRecommendationLog,
            selectedPreviewId,
            match,
            getAllImageList,
            onPreviewCancel,
            deleteImage,
            updateImage,
            viewOnly = false,
            hasGoToFunctionality = false,
            assignedRecoms = [],
            hasSurveyAssign = false,
            handleSurveyAssign,
            openExportToWordModalTrigger,
            onRefreshRecommendationsTable,
            hasSearchAndReplace,
            toggleSearchAndReplaceModal,
            isFound,
            groupEditProgressClick,
            showMultiEditPorgress,
            progressFailed
        } = this.props;
        const isEveryItemSelected = selectedRecomIds?.length === paginationParams.totalCount;
        let isConsultancyUser = localStorage.getItem("role") === "consultancy_user";
        let isSuperAdmin = localStorage.getItem("role") === "super_admin";
        let user_role = localStorage.getItem("role");
        let isCRApprover = user_role === "super_admin" || localStorage.getItem("crApprover") === "true";

        const opinionCostOptions = [
            { label: "All", value: null },
            ...(this.props.getOpinionsFilterResponse?.map(item => ({
                label: `${item.name?.trim()} (${item.count})`,
                value: item?.id?.toString()
            })) || [])
        ];

        const selectedOpinionCost =
            this.props.getOpinionsFilterResponse?.find(opt => opt?.id === this.props.tableParams?.opinions_cost_vs_project_total) || null;

        const selectedOpinionValue = selectedOpinionCost
            ? { label: `${selectedOpinionCost?.name?.trim()} (${selectedOpinionCost.count})`, value: selectedOpinionCost?.id?.toString() }
            : { label: "All", value: null };

        const { miscellaneous } = this.props.projectReducer.getProjectByIdResponse || {};
        const crLabel = getCapitalRequestLabel(miscellaneous);
        const SelectedRecom = tableData?.data?.find(e => e.id === selectedPreviewId);

        return (
            <React.Fragment>
                <div className={`dtl-sec ${this.props.tableWrapperClass} ${isBudgetPriority ? "pad-dtl-sec" : ""} rcom-tot-dtl col-md-12 mb-4`}>
                    <div className="table-top-menu allign-right top-head-wid" ref={this.toolbarRef}>
                        <div className="lft">
                            {section === "initiativeInfo" && (
                                <select
                                    className={
                                        this.props.selectedDropdownInitiaive === "active" && section !== "initiativeInfo"
                                            ? "form-control cstm-active"
                                            : "form-control"
                                    }
                                    value={this.props.selectedDropdownInitiaive}
                                    onChange={e => selectFilterHandlerInitiative(e)}
                                >
                                    <option value="all" className={"cstm-option"}>
                                        All
                                    </option>
                                    <option className={"cstm-option"} value="assigned">
                                        Assigned
                                    </option>
                                    <option className={"cstm-option"} value="unassigned">
                                        Unassigned
                                    </option>
                                </select>
                            )}
                        </div>
                        {section === "initiativeInfo" ? (
                            <div className="lft pl-2">
                                <select
                                    className={this.props.selectedDropdown === "active" ? "form-control cstm-active" : "form-control"}
                                    value={this.props.selectedDropdown}
                                    onChange={e => selectFilterHandlerInitiative(e)}
                                >
                                    <option className={"cstm-option"} value="allInitiative">
                                        All
                                    </option>
                                    <option className={"cstm-option"} value="locked">
                                        Locked
                                    </option>
                                    <option className={"cstm-option"} value="unlocked">
                                        Unlocked
                                    </option>
                                </select>
                            </div>
                        ) : null}
                        <div className="rgt justify-content-between">
                            {isBudgetPriority ? (
                                <div className={"hed-set budgt-head"}>
                                    <div class="tab-btn-dsh">
                                        <button class="btn-cmn btn-txt active">Budget Priorities</button>
                                        <button class="btn-cmn btn-icn">
                                            <img
                                                src={chartIcon}
                                                alt="wlt-icn"
                                                data-place="bottom"
                                                data-effect="solid"
                                                data-background-color="#007bff"
                                                onClick={() => this.props.toggleSecondChartView()}
                                                data-tip="FCI Benchmarking View"
                                                data-for="chrt"
                                            />
                                            <ReactTooltip id="chrt" />
                                        </button>
                                    </div>
                                    <div className="d-flex">
                                        <div className="d-flex filter-dash-otr align-items-center">
                                            <TableTopIcons
                                                tableData={tableData}
                                                globalSearchKey={globalSearchKey}
                                                handleGlobalSearch={handleGlobalSearch}
                                                resetAllFilters={resetAllFilters}
                                                toggleWildCardFilter={toggleWildCardFilter}
                                                showViewModal={showViewModal}
                                                showViewModalExport={showViewModalExport}
                                                showViewImport={showViewImport}
                                                resetSort={resetSort}
                                                tableParams={tableParams}
                                                isExport={isFullscreen ? hasExport : false}
                                                exportTableXl={this.props.exportTableXl}
                                                exportExcelAllTrades={false}
                                                tableLoading={this.props.tableLoading}
                                                exportAllTradesLoading={exportAllTradesLoading}
                                                exportWordLoading={exportWordLoading}
                                                selectFilterHandler={selectFilterHandler}
                                                isSelectFilter={true}
                                                entity={entity}
                                                hasHelp={isFullscreen}
                                                hasView={isFullscreen}
                                                hasNewlyCreated={isFullscreen && hasNewlyCreated}
                                                hasNewlyEdited={isFullscreen && hasNewlyEdited}
                                                updateTableSortFilters={updateTableSortFilters}
                                                updateLastSortFilter={updateLastSortFilter}
                                                hasViewMyRecommendation={isFullscreen && hasViewMyRecommendation}
                                                hasFilterByImages={isFullscreen && hasFilterByImages}
                                                filterBySurveyor={filterBySurveyor}
                                                hasIrRecommendation={isFullscreen && hasIrRecommendation}
                                                filterByImages={filterByImages}
                                                filterByIR={isFullscreen && filterByIR}
                                                resetAll={resetAll}
                                                isColunmVisibleChanged={isColunmVisibleChanged}
                                                showWildCardFilter={showWildCardFilter}
                                                selectedRecomIds={selectedRecomIds}
                                                clearSelection={clearSelection}
                                                toggleMoreFilter={this.toggleMoreFilter}
                                                isMoreFiltered={this.isMoreFiltered}
                                                hasAdditionalFilters={isFullscreen}
                                                isBudgetPriority
                                                isSmartChartView={this.props?.isSmartChartView}
                                                unPinAllColumn={this.props.unPinAllColumn}
                                                isRecommendationTable
                                                handleNormalRecomGrouping={this.props?.handleNormalRecomGrouping}
                                                isNormalRecomGroupingLoading={isNormalRecomGroupingLoading}
                                                isCapitalRequest={isCapitalRequest}
                                                RecommendationSection={this.props?.match?.params?.tab === "recommendations"}
                                                hasRecommendationTableLog={checkPermission("logs", "recommendation_logs", "view")}
                                                viewOnly={viewOnly}
                                                hasGoToFunctionality={hasGoToFunctionality}
                                                hasAdvancedSearch={true}
                                                hasSearchAndReplace={hasSearchAndReplace}
                                                toggleSearchAndReplaceModal={toggleSearchAndReplaceModal}
                                                groupEditProgressClick={groupEditProgressClick}
                                                showMultiEditPorgress={showMultiEditPorgress}
                                                progressFailed={progressFailed}
                                                isFound={isFound}
                                                openExportToWordModalTrigger={openExportToWordModalTrigger}
                                            />
                                        </div>
                                        <div className="btn-grp remove-when-downloading">
                                            <div
                                                className="fl-srn"
                                                data-place="left"
                                                data-effect="solid"
                                                data-delay-show="500"
                                                data-background-color="#007bff"
                                                data-tip={isFullscreen ? "Back To Normal Screen" : "View Full Screen"}
                                                data-for="budgetView"
                                                onClick={() => this.props.handleFullView()}
                                            >
                                                <img src="/img/restore.svg" alt="" className="set-icon-width" />
                                            </div>
                                            <ReactTooltip id="budgetView" />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <TableTopIcons
                                    tableData={tableData}
                                    globalSearchKey={globalSearchKey}
                                    handleGlobalSearch={handleGlobalSearch}
                                    resetAllFilters={resetAllFilters}
                                    toggleWildCardFilter={toggleWildCardFilter}
                                    showViewModal={showViewModal}
                                    resetSort={resetSort}
                                    tableParams={tableParams}
                                    isExport={hasExport}
                                    exportTableXl={this.props.exportTableXl}
                                    exportExcelAllTrades={exportExcelAllTrades}
                                    tableLoading={this.props.tableLoading}
                                    exportAllTradesLoading={exportAllTradesLoading}
                                    exportWordLoading={exportWordLoading}
                                    selectFilterHandler={selectFilterHandler}
                                    isSelectFilter={true}
                                    entity={entity}
                                    hasNewlyCreated={hasNewlyCreated}
                                    hasNewlyEdited={hasNewlyEdited}
                                    updateTableSortFilters={updateTableSortFilters}
                                    updateLastSortFilter={updateLastSortFilter}
                                    hasViewMyRecommendation={hasViewMyRecommendation}
                                    hasViewExportModal={this.props.hasViewExportModal}
                                    hasFilterByImages={hasFilterByImages}
                                    hasIrRecommendation={hasIrRecommendation}
                                    filterBySurveyor={filterBySurveyor}
                                    filterByImages={filterByImages}
                                    filterByIR={filterByIR}
                                    resetAll={resetAll}
                                    isColunmVisibleChanged={isColunmVisibleChanged}
                                    showWildCardFilter={showWildCardFilter}
                                    selectedRecomIds={selectedRecomIds}
                                    clearSelection={clearSelection}
                                    exportToWord={exportToWordFile}
                                    exportToExcel={exportToExcelFiles}
                                    showViewModalExport={showViewModalExport}
                                    showViewImport={showViewImport}
                                    toggleMoreFilter={this.toggleMoreFilter}
                                    isMoreFiltered={this.isMoreFiltered}
                                    hasAdditionalFilters={true}
                                    hasTableCellEdit={checkPermission("forms", "recommendations", "line_edit")}
                                    toggleLineEditing={toggleLineEditing}
                                    lineEditingEnabled={lineEditingEnabled}
                                    isSmartChartView={this.props?.isSmartChartView}
                                    unPinAllColumn={this.props.unPinAllColumn}
                                    openFiltersPopup={openFiltersPopup}
                                    isCrLinkPicker={isCrLinkPicker}
                                    filteredCount={filteredCount}
                                    dashboardFilterParams={dashboardFilterParams}
                                    myFilters={myFilters}
                                    toggleAppliedFiltersPopup={toggleAppliedFiltersPopup}
                                    isRecommendationTable
                                    handleNormalRecomGrouping={this.props?.handleNormalRecomGrouping}
                                    isNormalRecomGroupingLoading={isNormalRecomGroupingLoading}
                                    isCapitalRequest={isCapitalRequest}
                                    resetAllTableConfig={resetAllTableConfig}
                                    toggleQueriesModal={this.props.toggleQueriesModal}
                                    toggleSavedViewsModal={this.props.toggleSavedViewsModal}
                                    queries={this.props.queries}
                                    appliedTableView={this.props.appliedTableView}
                                    openRecommendationLog={openRecommendationLog}
                                    openExportToWordModalTrigger={openExportToWordModalTrigger}
                                    hasIconRefresh={
                                        !isBudgetPriority &&
                                        (match?.params?.tab === "recommendations" || isCapitalRequest) &&
                                        !this.props.isSmartChartView &&
                                        typeof onRefreshRecommendationsTable === "function"
                                    }
                                    iconRefreshTooltip={
                                        isCapitalRequest ? `Refresh ${crLabel}` : "Refresh Recommendations"
                                    }
                                    handleRefresh={onRefreshRecommendationsTable}
                                    RecommendationSection={this.props?.match?.params?.tab === "recommendations"}
                                    hasRecommendationTableLog={checkPermission("logs", "recommendation_logs", "view")}
                                    children={
                                        <>
                                            {this.props.isImageView ? (
                                                <>
                                                    <button
                                                        className={!selectedRecomIds.length ? "add-btn disabled-btn mr-2" : "add-btn mr-2"}
                                                        disabled={!selectedRecomIds.length}
                                                        onClick={() => this.props.unAassignContent()}
                                                    >
                                                        <i className="fas fa-minus" /> Unassign Image
                                                    </button>
                                                </>
                                            ) : section === "recommendationsinfo" && isCapitalRequest ? null : isCapitalRequest && showAddButton ? (
                                                <button className="add-btn" onClick={() => showAddForm()}>
                                                    <i className="fas fa-plus" /> Add New {crLabel}
                                                </button>
                                            ) : isCrLinkedRecommendations && !isCrLinkPicker ? (
                                                <>
                                                    {isCRApprover && (
                                                        <>
                                                            <button
                                                                className={"add-btn mr-2"}
                                                                onClick={() => toggleLinkRecommendationModal()}
                                                                data-tip={`Link existing recommendations to this ${crLabel}`}
                                                                data-for="cr-link-actions"
                                                            >
                                                                <i className="fas fa-link" /> Link Recommendations
                                                            </button>
                                                            <button
                                                                className={"add-btn mr-2"}
                                                                onClick={() => createRecommendationFromCr()}
                                                                data-tip={`Create a new recommendation from this ${crLabel}`}
                                                                data-for="cr-link-actions"
                                                            >
                                                                <i className="fas fa-plus" /> Create New Recommendation
                                                            </button>
                                                            <ReactTooltip
                                                                id="cr-link-actions"
                                                                effect="solid"
                                                                place="top"
                                                                className="cr-link-actions-tip"
                                                                backgroundColor="#007bff"
                                                            />
                                                        </>
                                                    )}
                                                </>
                                            ) : !this.props.isChartView &&
                                              !isBuildingLocked &&
                                              !isBudgetPriority &&
                                              section !== "assetInfo" &&
                                              section !== "initiativeInfo" &&
                                              !this.props.isSmartChartView &&
                                              showAddButton ? (
                                                <button
                                                    className={`add-btn ${
                                                        this?.props?.isMobileRequest && this.props?.showRecommendationAddBtn ? "cursor-diabled" : ""
                                                    }`}
                                                    onClick={() => showAddForm()}
                                                    disabled={this?.props?.isMobileRequest && this.props?.showRecommendationAddBtn}
                                                    data-tip={
                                                        this?.props?.isMobileRequest &&
                                                        this.props?.showRecommendationAddBtn &&
                                                        "New fields exist, please handle them to add new mobile recommendations."
                                                    }
                                                    data-for={
                                                        this?.props?.isMobileRequest && this.props?.showRecommendationAddBtn ? "table top icons" : ""
                                                    }
                                                >
                                                    <i className="fas fa-plus" />{" "}
                                                    {this?.props?.isMobileRequest ? "Add New Mobile Based Rec." : "Add Recommendation"}
                                                </button>
                                            ) : null}
                                            {section === "assetInfo" && showAddButton ? (
                                                <button className="add-btn" onClick={() => createAssetRecommendation()}>
                                                    <i className="fas fa-plus" /> Create Service Life Recommendation
                                                </button>
                                            ) : null}
                                            {section === "initiativeInfo" && this.props.match.params.tab === "recommendation" && (
                                                <>
                                                    {this.props.selectedDropdownInitiaive === "unassigned" ? (
                                                        <button
                                                            className={!this.props.enableButton ? "add-btn mr-2 disabled-btn" : "add-btn mr-2"}
                                                            disabled={!this.props.enableButton}
                                                            onClick={() => this.assignContent()}
                                                        >
                                                            <i className="fas fa-plus" /> Assign Initiative
                                                        </button>
                                                    ) : this.props.selectedDropdownInitiaive === "assigned" ? (
                                                        <button
                                                            className={!this.props.enableButton ? "add-btn disabled-btn" : "add-btn"}
                                                            disabled={!this.props.enableButton}
                                                            onClick={() => this.props.unAassignContent()}
                                                        >
                                                            <i className="fas fa-minus" /> Unassign Initiative
                                                        </button>
                                                    ) : null}
                                                </>
                                            )}
                                        </>
                                    }
                                    viewOnly={viewOnly}
                                    hasAdvancedSearch={true}
                                    hasSearchAndReplace={hasSearchAndReplace}
                                    toggleSearchAndReplaceModal={toggleSearchAndReplaceModal}
                                    groupEditProgressClick={groupEditProgressClick}
                                    showMultiEditPorgress={showMultiEditPorgress}
                                    progressFailed={progressFailed}
                                    isFound={isFound}
                                />
                            )}
                        </div>
                    </div>
                    <div className="d-flex wrapper-icon-full" ref={this.selectionBarRef}>
                        {selectedRecomIds?.length > 0 && (
                            <>
                                <button
                                    className={`add-btn ml-2 btn-new-noti ${viewOnly ? "cursor-disabled" : ""}`}
                                    onClick={e => e.preventDefault()}
                                >
                                    <i className="fas fa-check" />
                                    <span>{selectedRecomIds?.length}</span>
                                </button>
                                <button
                                    className={`add-btn ml-2 btn-new-noti ${viewOnly ? "cursor-disabled" : ""}`}
                                    onClick={e => {
                                        e.preventDefault();
                                        clearSelection();
                                    }}
                                    disabled={viewOnly}
                                >
                                    <i className="fas fa-times-circle mr-1" /> {`Clear`}
                                </button>
                                {isCrLinkedRecommendations && !isCrLinkPicker && isCRApprover && (
                                    <button className={"add-btn ml-2 btn-new-noti"} onClick={() => unlinkSelectedRecommendations()}>
                                        <i className="fas fa-unlink mr-1" /> {`Unlink`}
                                    </button>
                                )}
                                {!this.props.isSmartChartView && section !== "initiativeInfo" && !isCrLinkedRecommendations && (
                                    <>
                                        {hasEdit && (
                                            <button className={"add-btn ml-2 btn-new-noti"} onClick={() => handleEditMultiSelectedData()}>
                                                <i className="fas fa-pencil-alt mr-1" /> {`Edit`}
                                            </button>
                                        )}
                                        {checkPermission("forms", permissionConfig.RECOMMENDATION_SHIFT_CSP, "edit") && (
                                            <button className={"add-btn ml-2 btn-new-noti"} onClick={() => toggleShiftCspModal()}>
                                                <i class="fas fa-exchange-alt mr-1"></i>
                                                {`Shift CSP`}
                                            </button>
                                        )}
                                        <BulkQaQc
                                            recommendationIds={selectedRecomIds}
                                            projectId={this.props.projectReducer?.getProjectByIdResponse?.id}
                                            onCompleted={this.props.onBulkQaCompleted}
                                        />
                                        {hasEdit && (
                                            <BulkQaStatusUpdate
                                                recommendationIds={selectedRecomIds}
                                                projectId={this.props.projectReducer?.getProjectByIdResponse?.id}
                                                viewOnly={viewOnly}
                                                onCompleted={this.props.onBulkQaCompleted}
                                            />
                                        )}
                                    </>
                                )}
                                <button
                                    className={`add-btn ml-2 btn-new-noti ${viewOnly ? "cursor-disabled" : ""}`}
                                    onClick={e => {
                                        e.preventDefault();
                                        showSelectedRecom();
                                    }}
                                    disabled={viewOnly}
                                >
                                    <i className="fas fa-eye mr-1" />
                                    {tableParams.recommendation_ids?.length ? " Show All" : " Show"}
                                </button>
                                {!this.props.isSmartChartView && hasExport && !isCrLinkedRecommendations ? (
                                    <Dropdown className="export-btn-drop" show={this.state.show}>
                                        <Dropdown.Toggle
                                            id="dropdown-basic"
                                            onClick={() => this.setState({ show: !this.state.show })}
                                            className="add-btn ml-2 btn-new-noti export-btn"
                                        >
                                            {multiExportPdfLoader || multiExportWordLoader ? (
                                                <div className="edit-icn-bx icon-btn-sec export-loader">
                                                    <div className="spinner-border text-primary" role="status"></div>
                                                </div>
                                            ) : (
                                                <i className="fas fa-print mr-1"></i>
                                            )}
                                            Print
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            <Dropdown.Item>
                                                <i className="fas fa-solid fa-file-word mr-1" />
                                                Word
                                            </Dropdown.Item>
                                            <div class="brief-desc flex-wrap print-recom-mode">
                                                <div class="seting-type checkbox-container print-mode">
                                                    <label class="container-checkbox cursor-hand m-0">
                                                        <input
                                                            type="checkbox"
                                                            checked={this.state.isCheckedWord}
                                                            onChange={e => this.toggleChangeWord(e, "isCheckedWordDefault")}
                                                        />
                                                        <span class="checkmark"></span>With Narrative
                                                    </label>
                                                    <label class="container-checkbox cursor-hand m-0">
                                                        <input
                                                            type="checkbox"
                                                            checked={!this.state.isCheckedWord}
                                                            onChange={e => this.toggleChangeWord(e, "isCheckedWord")}
                                                        />
                                                        <span class="checkmark"></span>Without Narrative
                                                    </label>
                                                </div>
                                                {this.state.isCheckedWord && (
                                                    <div class="seting-type checkbox-container print-mode">
                                                        <label class="container-checkbox cursor-hand m-0">
                                                            <input
                                                                type="checkbox"
                                                                checked={this.state.isSimpleNarrativeTextWord}
                                                                onChange={e => this.setState({ isSimpleNarrativeTextWord: true })}
                                                            />
                                                            <span class="checkmark"></span>Simple Narrative Text in table
                                                        </label>
                                                        <label class="container-checkbox cursor-hand m-0">
                                                            <input
                                                                type="checkbox"
                                                                checked={!this.state.isSimpleNarrativeTextWord}
                                                                onChange={e => this.setState({ isSimpleNarrativeTextWord: false })}
                                                            />
                                                            <span class="checkmark"></span>Rich Narrative Text
                                                        </label>
                                                    </div>
                                                )}
                                                <button
                                                    className="dwd-btn mt-3"
                                                    onClick={() => {
                                                        exportSelectedRecom("word", {
                                                            isChecked: this.state.isCheckedWord,
                                                            isSimpleNarrativeText: this.state.isSimpleNarrativeTextWord
                                                        });
                                                        this.clearExport();
                                                        this.setState({ show: false });
                                                    }}
                                                >
                                                    <i className="fas fa-file-download mr-2"></i>
                                                    Download
                                                </button>
                                            </div>

                                            <Dropdown.Item>
                                                <i className="fas fa-solid fa-file-pdf mr-1" />
                                                PDF
                                            </Dropdown.Item>
                                            <div class="brief-desc flex-wrap print-recom-mode">
                                                <div class="seting-type checkbox-container print-mode">
                                                    <label class="container-checkbox cursor-hand m-0">
                                                        <input
                                                            type="checkbox"
                                                            checked={this.state.isCheckedPdf}
                                                            onChange={e => this.toggleChangePdf(e, "isCheckedPdfDefault")}
                                                        />
                                                        <span class="checkmark"></span>With Narrative
                                                    </label>
                                                    <label class="container-checkbox cursor-hand m-0">
                                                        <input
                                                            type="checkbox"
                                                            checked={!this.state.isCheckedPdf}
                                                            onChange={e => this.toggleChangePdf(e, "isCheckedPdf")}
                                                        />
                                                        <span class="checkmark"></span>Without Narrative
                                                    </label>
                                                </div>
                                                {this.state.isCheckedPdf && (
                                                    <div class="seting-type checkbox-container print-mode">
                                                        <label class="container-checkbox cursor-hand m-0">
                                                            <input
                                                                type="checkbox"
                                                                checked={this.state.isSimpleNarrativeTextPdf}
                                                                onChange={e => this.setState({ isSimpleNarrativeTextPdf: true })}
                                                            />
                                                            <span class="checkmark"></span>Simple Narrative Text in table
                                                        </label>
                                                        <label class="container-checkbox cursor-hand m-0">
                                                            <input
                                                                type="checkbox"
                                                                checked={!this.state.isSimpleNarrativeTextPdf}
                                                                onChange={e => this.setState({ isSimpleNarrativeTextPdf: false })}
                                                            />
                                                            <span class="checkmark"></span>Rich Narrative Text
                                                        </label>
                                                    </div>
                                                )}
                                                <button
                                                    className="dwd-btn mt-3"
                                                    onClick={() => {
                                                        exportSelectedRecom("pdf", {
                                                            isChecked: this.state.isCheckedPdf,
                                                            isSimpleNarrativeText: this.state?.isSimpleNarrativeTextPdf
                                                        });
                                                        this.clearExport();
                                                        this.setState({ show: false });
                                                    }}
                                                >
                                                    <i className="fas fa-file-download mr-2"></i>
                                                    Download
                                                </button>
                                            </div>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                ) : null}
                                {paginationParams?.totalCount > paginationParams?.perPage && (
                                    <button
                                        className={`add-btn ml-2 btn-new-noti btn-sel-all ${isEveryItemSelected ? "active" : ""} ${
                                            viewOnly ? "cursor-disabled" : ""
                                        }`}
                                        onClick={e => {
                                            e.preventDefault();
                                            selectWholeRecommendation();
                                        }}
                                        disabled={viewOnly}
                                    >
                                        <i className="fas fa-check-double mr-1" /> {isEveryItemSelected ? "Selected All" : "Select All"}{" "}
                                        <span>{paginationParams?.totalCount}</span>
                                    </button>
                                )}
                                {hasSurveyAssign && !isCrLinkPicker && (
                                    <>
                                        <button
                                            class="add-btn ml-2 btn-new-noti"
                                            type="button"
                                            onClick={() => handleSurveyAssign(selectedRecomIds, "assign")}
                                        >
                                            <i className="fas fa-plus mr-1" /> Assign Recommendations
                                        </button>
                                        <button
                                            class="add-btn ml-2 btn-new-noti"
                                            type="button"
                                            onClick={() => handleSurveyAssign(selectedRecomIds, "unassign")}
                                        >
                                            <i className="fas fa-minus mr-1" /> Unassign Recommendations
                                        </button>
                                    </>
                                )}
                            </>
                        )}
                    </div>
                    <div class={`collapse-outer col-md-12 p-0  ${this.state.showMoreFilter ? "tog-cls" : ""} `} ref={this.filterPanelRef}>
                        <MoreFilters
                            isBudgetPriority={isBudgetPriority}
                            isCapitalRequest={isCapitalRequest}
                            isSmartChartView={isSmartChartView}
                            viewOnly={viewOnly}
                            section={section}
                            hasViewMyRecommendation={hasViewMyRecommendation}
                            hasFilterByMyQa={hasFilterByMyQa}
                            hasFilterByQaStatus={hasFilterByQaStatus}
                            isConsultancyUser={isConsultancyUser}
                            isSuperAdmin={isSuperAdmin}
                            miscellaneous={miscellaneous}
                            tableParams={tableParams}
                            opinionCostOptions={opinionCostOptions}
                            selectedOpinionValue={selectedOpinionValue}
                            selectedDropdown={this.props.selectedDropdown}
                            onStatusChange={value => this.props.selectFilterHandler(value)}
                            filterBySurveyor={filterBySurveyor}
                            filterByAnyKey={this.props.filterByAnyKey}
                            filterByOpinionsCost={this.props.filterByOpinions_cost}
                            filterByReviews={filterByReviews}
                            filterByQaStatus={filterByQaStatus}
                            getListForCommonFilterRecommendation={this.props.getListForCommonFilterRecommendation}
                        />
                    </div>
                    <div
                        className={`recommendations-table ${
                            this.state.showMoreFilter && selectedRecomIds?.length
                                ? "more-check-combine"
                                : this.state.showMoreFilter
                                ? "more-inf-added"
                                : selectedRecomIds?.length
                                ? "table-hgt-check"
                                : ""
                        } ${isSmartChartView && !selectedRecomIds?.length ? "recom-smart-modl" : ""}`}
                    >
                        {isTableResetting ? (
                            <div className="table-section table-scroll table-gen-overflow overflow-hght no-data-table">
                                <table className="table table-common table-min-height"></table>
                            </div>
                        ) : (
                            <div className="d-flex">
                                <Table
                                    updateCurrentViewAllUsers={updateCurrentViewAllUsers}
                                    tableData={tableData}
                                    currentViewAllUsers={currentViewAllUsers}
                                    handleDeleteItem={handleDeleteRecommendations}
                                    showWildCardFilter={showWildCardFilter}
                                    showEditPage={showEditPage}
                                    showInfoPage={showInfoPage}
                                    updateSelectedRow={updateSelectedRow}
                                    selectedRowId={selectedRowId}
                                    updateWildCardFilter={updateWildCardFilter}
                                    wildCardFilter={wildCardFilter}
                                    handleHideColumn={handleHideColumn}
                                    getListForCommonFilter={getListForCommonFilterRecommendation}
                                    updateCommonFilter={updateCommonFilter}
                                    commonFilter={commonFilter}
                                    hasActionColumn={
                                        !(
                                            this.props.isChartView ||
                                            this.props.isAssetView ||
                                            isCrLinkPicker ||
                                            (isBudgetPriority && !isFullscreen) ||
                                            (this.props.isSmartChartView && !hasSurveyAssign)
                                        )
                                    }
                                    updateTableSortFilters={updateTableSortFilters}
                                    tableParams={tableParams}
                                    isBuildingLocked={this.props.isBuildingLocked}
                                    summaryRowData={summaryRowData}
                                    showRestoreModal={showRestoreModal}
                                    permissions={permissions}
                                    handleSelect={this.props.handleSelect}
                                    handleSelectAll={this.props.handleSelectAll}
                                    recomentationIds={this.props.recomentationIds}
                                    currentPage={paginationParams.currentPage}
                                    selectedAllClicked={this.state.selectedAll}
                                    resetSelect={this.resetSelect}
                                    hasEdit={hasEdit}
                                    hasDelete={hasDelete}
                                    hasInfoPage={hasInfoPage}
                                    selectedRecomIds={selectedRecomIds}
                                    handleSelectRecom={handleSelectRecom}
                                    handleSelectAllRecom={handleSelectAllRecom}
                                    isBudgetPriority={isBudgetPriority}
                                    isFullscreen={isFullscreen}
                                    tableRef={tableRef}
                                    hasMultiAction={hasMultiAction}
                                    everyItemCheckedPerPage={everyItemCheckedPerPage}
                                    priorityElementsData={priorityElementsData}
                                    exportFilters={tableDataExportFilters}
                                    isInputMode={isInputMode}
                                    handleCellFocus={handleCellFocus}
                                    handleCellValueChange={handleCellValueChange}
                                    handleColumnPin={handleColumnPin}
                                    updateColumnWidthInConfig={updateColumnWidthInConfig}
                                    pinnedColumnsRef={pinnedColumnsRef}
                                    hasPin={true}
                                    lineEditingEnabled={lineEditingEnabled}
                                    isSmartChartView={this.props.isSmartChartView}
                                    additionalTableClass={
                                        section === "imageInfo" ? "table-img-filheight" : lineEditingEnabled ? "overf-fullscreen-hght" : ""
                                    }
                                    lineEditDropdownValue={this.props?.lineEditDropdownValue}
                                    lineEditSuggestionValue={this.props?.lineEditSuggestionValue}
                                    hasPrefixSuggestionMatch={this.props?.hasPrefixSuggestionMatch}
                                    isDropdownLoading={this.props?.isDropdownLoading}
                                    hasPaneView={match?.params?.tab === "recommendations" || false}
                                    OnPaneViewClick={this.props?.OnPaneViewClick}
                                    paneViewEnabled={this.props?.paneViewEnabled}
                                    isRecommendationTable
                                    viewOnly={viewOnly}
                                    parentLoading={this.props.parentLoading}
                                    assignedRows={assignedRecoms}
                                    handleSurveyAssign={handleSurveyAssign}
                                    hasSurveyAssign={hasSurveyAssign}
                                    isSurveyRecom={this.props?.isAssignRecomView}
                                    searchField={this.props?.searchField}
                                    setSearchField={this.props?.setSearchField}
                                    highlightSearchField={this.props?.setHighlightSearchField}
                                    findAndReplaceParams={isFound}
                                />
                                {SelectedRecom?.id && match?.params?.tab === "recommendations" && (
                                    <RecommendationPreview
                                        selectedRecom={SelectedRecom || {}}
                                        viewImageModal={this.setSelectedImage}
                                        imageList={this.props?.imageResponse || []}
                                        getAllImageList={getAllImageList}
                                        onPreviewCancel={onPreviewCancel}
                                        deleteImage={deleteImage}
                                        updateImage={updateImage}
                                        showMoreFilter={this.state?.showMoreFilter || false}
                                    />
                                )}
                            </div>
                        )}
                        {tableData.data && tableData.data.length ? (
                            <div className="table-bottom d-flex">
                                <div className="count d-flex col-md-6">
                                    <div className="count-dtl">
                                        Total Count: <span>{paginationParams.totalCount}</span>
                                    </div>
                                    <div className="col-md-2 pr-2 selbx">
                                        <select className="form-control" value={paginationParams.perPage} onChange={e => handlePerPageChange(e)}>
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="30">30</option>
                                            <option value="40">40</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                            <option value="150">150</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="pagination-sec col-md-6">
                                    <ReactPaginate
                                        previousLabel={
                                            <span data-place="top" data-effect="solid" data-tip={`Previous`} data-background-color="#007bff">
                                                &lt;
                                            </span>
                                        }
                                        nextLabel={
                                            <span data-place="top" data-effect="solid" data-tip={`Next`} data-background-color="#007bff">
                                                &gt;
                                            </span>
                                        }
                                        breakLabel={"..."}
                                        breakClassName={"break-me"}
                                        pageCount={paginationParams.totalPages}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={isBudgetPriority ? 1 : 5}
                                        onPageChange={handlePageClick}
                                        containerClassName={"pagination"}
                                        subContainerClassName={"pages pagination"}
                                        activeClassName={"active"}
                                        activeLinkClassName={"active"}
                                        forcePage={paginationParams.currentPage}
                                    />
                                    <ReactTooltip />
                                </div>
                            </div>
                        ) : null}
                    </div>{" "}
                    <ReactTooltip id="toggle-div" effect="solid" className="rc-tooltip-custom-class" place="top" backgroundColor="#007bff" />
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    const { siteReducer, projectReducer } = state;
    return { siteReducer, projectReducer };
};

export default withRouter(connect(mapStateToProps, { ...recommendationsActions, ...projectActions })(RecommendationsMain));
